// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"8e35f621","354":"24ea3328","838":"dbd4a9e1"}[chunkId] + ".js";
};